module.exports = __webpack_public_path__ + "img/logo-parent_client.0ac8dd04.svg";